<template>
  <el-dialog
    title="管理列"
    :visible.sync="visible"
    width="500px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div class="column-list">
      <div
        v-for="(column, index) in localColumns"
        :key="column.id"
        class="column-item"
      >
        <div class="column-info">
          <el-color-picker v-model="column.color" size="mini" show-alpha />
          <el-input v-model="column.name" size="small" style="width: 150px; margin: 0 10px;" />
          <el-input-number v-model="column.wip_limit" size="mini" :min="0" :max="50" placeholder="WIP限制" style="width: 80px;" />
        </div>
        <div class="column-actions">
          <el-button type="text" :disabled="index === 0" @click="moveUp(index)">
            <i class="el-icon-arrow-up" />
          </el-button>
          <el-button type="text" :disabled="index === localColumns.length - 1" @click="moveDown(index)">
            <i class="el-icon-arrow-down" />
          </el-button>
          <el-button type="text" style="color: #F56C6C;" @click="removeColumn(index)">
            <i class="el-icon-delete" />
          </el-button>
        </div>
      </div>
    </div>

    <div class="add-column-section">
      <el-button type="primary" plain icon="el-icon-plus" size="small" @click="addColumn">
        添加新列
      </el-button>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="handleSave">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateColumn, createColumn, deleteColumn } from '@/api/task'

export default {
  name: 'ColumnDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    columns: {
      type: Array,
      default: () => []
    },
    boardId: {
      type: [Number, null],
      default: null
    }
  },
  data() {
    return {
      submitting: false,
      localColumns: []
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.localColumns = this.columns.map(col => ({
          ...col,
          isNew: false,
          isDeleted: false
        }))
      }
    }
  },
  methods: {
    addColumn() {
      this.localColumns.push({
        id: null,
        name: '新列',
        color: '#409EFF',
        wip_limit: null,
        sort_order: this.localColumns.length,
        isNew: true,
        isDeleted: false
      })
    },
    removeColumn(index) {
      const col = this.localColumns[index]
      if (col.id) {
        col.isDeleted = true
      } else {
        this.localColumns.splice(index, 1)
      }
    },
    moveUp(index) {
      if (index === 0) return
      const temp = this.localColumns[index]
      this.$set(this.localColumns, index, this.localColumns[index - 1])
      this.$set(this.localColumns, index - 1, temp)
    },
    moveDown(index) {
      if (index === this.localColumns.length - 1) return
      const temp = this.localColumns[index]
      this.$set(this.localColumns, index, this.localColumns[index + 1])
      this.$set(this.localColumns, index + 1, temp)
    },
    async handleSave() {
      this.submitting = true
      try {
        // 过滤出需要操作的列
        const toCreate = this.localColumns.filter(col => col.isNew && !col.isDeleted)
        const toUpdate = this.localColumns.filter(col => !col.isNew && !col.isDeleted)
        const toDelete = this.localColumns.filter(col => col.isDeleted && col.id)

        // 创建新列
        for (const col of toCreate) {
          await createColumn({
            board_id: this.boardId,
            name: col.name,
            color: col.color,
            wip_limit: col.wip_limit,
            sort_order: this.localColumns.indexOf(col)
          })
        }

        // 更新现有列
        for (const col of toUpdate) {
          await updateColumn(col.id, {
            name: col.name,
            color: col.color,
            wip_limit: col.wip_limit,
            sort_order: this.localColumns.indexOf(col)
          })
        }

        // 删除列
        for (const col of toDelete) {
          await deleteColumn(col.id)
        }

        this.$message.success('保存成功')
        this.$emit('success')
        this.$emit('update:visible', false)
      } catch (error) {
        console.error('保存失败:', error)
        this.$message.error('保存失败')
      } finally {
        this.submitting = false
      }
    },
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.column-list {
  max-height: 400px;
  overflow-y: auto;
}

.column-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  margin-bottom: 10px;
  background: #f5f7fa;
  border-radius: 6px;

  &.is-deleted {
    opacity: 0.5;
    text-decoration: line-through;
  }
}

.column-info {
  display: flex;
  align-items: center;
}

.column-actions {
  display: flex;
  gap: 5px;
}

.add-column-section {
  margin-top: 15px;
  text-align: center;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}
</style>
